<!--  -->
<template>
    <div class="allLinecontainer">
        <button @click="back">
            <iconx type="tuichu"></iconx>  {{isEnglish? 'Exit route':'退出路线'}} 
        </button>
        <div class="linemain">
            <Swipe class="my-swipe"  ref="swipe" indicator-color="white" :initial-swipe="tabCheck" @change="onChange" >
                <SwipeItem v-for="(v,i) in tourInfo" :key="i"  >
                   <div class="title">
                        <h3>{{ isEnglish? v.name_eng: v.name}}</h3>
                        <p>{{v.tourCount ?v.tourCount  :''}}</p>
                   </div>
                   
                </SwipeItem>
                
                <!-- <template #indicator>
                    <div class="custom-indicator">
                        <div>

                        </div>
                    </div>
                </template> -->
               
                
            </Swipe>
            <div class="lineList">
                        <div v-for="(v,i) in tourInfo" :key="i" v-show="i==toogle" >
                            <div v-for="(item,index) in v.bitchIds" :key="item.id" @click="watchTour(item)">
                                <p>
                                    <span class="size">{{index+1}}</span>
                                    <span>{{isEnglish?item.name_eng:  item.name}}</span>
                                </p>

                            </div>
                        </div>
                   </div>
            
        </div>
    </div>
</template>
<script>
import iconx from "@/components/iconx.vue";
import { Swipe, SwipeItem } from 'vant';
import eventBus from "@/utils/eventBus";

export default {
    components:{
        iconx,
        Swipe,
        SwipeItem,
    },
    props:{
        tabCheck:{
            type:Number,
            default:1
        },
        closeDialog:{
            type:Function
        },
        backRoad:{
            type:Function
        },
        isEnglish:{
            type:Boolean
        }

    },
    data() {
        return {
            tourInfo:{},
            toogle:0
           
        }
    },
    created() {
         this.tourInfo=JSON.parse(localStorage.getItem("tourInfo")).path_planning
    },
    mounted() {
        // this.$refs.swipe.resize();
        // this.tabCheck=this.$route.query.id
        this.toogle=this.tabCheck
    },
    methods:{
        watchTour(data){
            eventBus.emit("showInfoWindow", data);
            this.$emit("closeDialog",false)

        },
        onChange(index){
            console.log(index)
            this.toogle=index
             eventBus.emit("setLineVis", index);
             eventBus.emit("lineTour",this.tourInfo[index].bitchIds)
            // this.tabCheck=index
        },
        back(){
            this.$emit("backRoad",true)
            eventBus.emit("setLineVis", null);
            eventBus.emit("lineTour",{})
            eventBus.emit("remove", 0);

            
        }
    }
}
</script>
<style scoped lang="scss">
    .allLinecontainer{
        width: 100%;
        height: 200px;
        position: fixed;
        bottom: 0rem;
        // left: 0;
        // display: flex;
        //  overflow-y: auto;
        background: #fff;
        z-index: 9999;
        button{
            position: absolute;
            top: -1rem;
            left: .3rem;
            background: #fff;
            border: none;
            width: 1.5rem;
            height: .6rem;
            border-radius: .7rem;
            display: flex;
            align-items: center;
            justify-content: center;
            i{
                font-size: 22px;
                transform: rotateZ(180deg);
            }
        }
       .title{
            padding: .3rem;
                box-sizing: border-box;
           h3{
               
                font-size: 20px;
                font-weight: normal;
                color: #555; 
               

            }
            p{
                font-size: 12px;
                color: #555;
            }
       }
        
        .linemain{
            flex: 1;
            display: flex;
            flex-direction: column;
            height: 100%;
            //  overflow-y: auto;

           > .my-swipe {
               width: 100%;
               position: relative;
            //    height: 300px;
               overflow:hidden;
              /deep/ .van-swipe__track {
                  width: 100%;
                   display: flex !important;
                   height: 100%;
               }
              /deep/ .van-swipe__indicators{
                   position: absolute;
                   top: 1.3rem;
                left: 50%;
                // width: 55%;
                height: 10px;
                transform: translatex( -50%);
                display: flex;
                
               }
              /deep/ .van-swipe__indicator--active {
                  display: flex;
                  
                    background: #FF8C00 !important;
                    opacity: 1 !important;
                    
                }
                /deep/  .van-swipe__indicator {
                  display: flex;
                    width: 10px;
                    height: 6px;
                    background: #000;
                    opacity: .2;
                    border-radius: 3px;
                    margin-right: 10px;
                }
                /deep/  .van-swipe-item{
                    // float: left;
                    flex: none;
                    // width: 100% !important;
                    display: flex;
                    flex-direction: column;
                }
                
           }
           
            .lineList{
                    flex: 1;
                    display: flex;
                    // overflow-y: auto;
                    // background: red;
                    padding-top: .3rem;
                    >div{
                        flex: none;
                    // overflow-y: auto;
                        width: 100%;
                        border-top: 1px solid #ccc;
                        font-size: 16px;
                        padding: 0 .3rem;
                        box-sizing: border-box;
                        display: flex;
                        flex-wrap: nowrap;
                        overflow-x: auto;
                        >div{
                            flex: none;
                            width: auto;
                            display: flex;
                            padding:  0 .3rem;
                            box-sizing: border-box;
                        }
                        p{
                            flex: none;
                            width: auto;
                            padding: .2rem 0;
                            box-sizing: border-box;
                            display: flex;
                            align-items: center;
                            .size{
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                border: 1px solid #00FFFF;
                                width: 25px;
                                height: 25px;
                                border-radius: 100%;
                                font-size: 14px;
                                margin-right:.1rem;
                                box-sizing: border-box;
                                color: #00FFFF;
                                // padding: .1rem;
                                // box-sizing: border-box;
                            }
                        }
                    }
                    >div::-webkit-scrollbar{
                        display: none;
                        width: 0;
                        height: 0;
                    }
                }
         
           
        }
        
    }
</style>


// WEBPACK FOOTER //
// src/components/tourLineMsg.vue